<template>
    <div>
        <base-page
            title="材料上传成功"
            content="客服会尽快为您处理，请您耐心等待"
            :pic="IMAGE_MAP.UPLOADED_PAGE_ICON"
        ></base-page>
        <view-progress :mustLoggedOn="mustLoggedOn"></view-progress>
    </div>
</template>

<script>
import BasePage from './BasePage.vue';
import ViewProgress from '@/components/ViewProgress.vue';
import { getFixedImgUrl } from '@/utils/dynamic-cdn';
const IMAGE_MAP = getFixedImgUrl();

export default {
    name: 'uploaded-page',
    props: {
        mustLoggedOn: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            IMAGE_MAP,
        };
    },
    components: {
        BasePage,
        ViewProgress,
    },
};
</script>
